import { css } from '@emotion/react'
import styled from '@emotion/styled'
import StarRoundedIcon from '@mui/icons-material/StarRounded'
import { Typography } from 'components'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  .MuiAccordion-root {
    box-shadow: none;
    padding: ${theme.spacing.xm};
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.spacing.xm};
  gap: ${theme.spacing.xm};
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const TitleRow = styled(Row)`
  justify-content: space-between;
`

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${theme.shapes.borderRadius.xm};
  gap: ${theme.spacing.xm};
  padding: ${theme.spacing.xm};
  background: ${theme.colors.neutral.white};
  box-shadow: ${theme.effects.boxShadow['rule-01']};
`

type OfficeTitleProps = {
  color?: string
}
export const OfficeTitle = styled(Typography)<OfficeTitleProps>`
  font-size: ${theme.typography.sizes.md};
  color: ${theme.colors.neutral.high};
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`

export const OfficeTooltip = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
  border-radius: 6px;
  padding: 0 ${theme.spacing.sm};
  background-color: ${theme.colors.alert.info.ligther};

  p.office-info {
    color: ${theme.colors.alert.info[40]} !important;
  }
`

export const RowDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${theme.colors.neutral.clear};
`

export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};

  label {
    font-size: ${theme.typography.sizes.xs};
  }
`

export const TitleDivider = styled.div`
  width: 1px;
  height: 20px;
  background-color: ${theme.colors.neutral.lighthover};
`

type DataWrapProps = {
  achieved?: boolean
}
export const DataWrap = styled.div<DataWrapProps>`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};

  ${({ achieved }) =>
    achieved &&
    css`
      svg {
        path {
          fill: ${theme.colors.alert.success.dark};
        }
      }

      span {
        color: ${theme.colors.alert.success.dark};
        font-family: ${theme.typography.family.bold};
      }
    `}
`

export const EmptyIcon = styled.div`
  width: 16px;
  height: 16px;
`

export const StarIcon = styled(StarRoundedIcon)`
  font-size: 16px;
`

export const MetaWrap = styled.div`
  display: flex;
  flex-direction: column;
`

export const MetaLabel = styled(Typography)`
  font-size: ${theme.typography.sizes['3xs']};
`
export const MetaValue = styled(Typography)`
  color: ${theme.colors.alert.info[40]} !important;
`

export const TabsWrapper = styled.div`
  #action-tabs-wrap {
    margin: 0;
    padding: 0 ${theme.spacing.md};

    button {
      font-size: ${theme.typography.sizes['2xs']};
      padding: ${theme.spacing.sm} ${theme.spacing.md};
    }
  }
`

export const ReportRow = styled(Row)`
  gap: 8px;
`
